import { gql, useMutation } from '@apollo/client';
import { StructParams } from '@lib/structures';
import { useCallback } from 'react';

interface MutationParams {
  idnumber: string;
  roleName: string;
  structures: StructParams[];
}

type HookReturns = [
  (
    idnumber: string,
    roleName: string,
    structures: StructParams[]
  ) => Promise<void>,
  { loading: boolean },
];

const addMutation = gql`
  mutation addGeorole(
    $idnumber: String!
    $roleName: String!
    $structures: [StructureInput]!
  ) {
    grantGeorole(
      idnumber: $idnumber
      roleName: $roleName
      structures: $structures
    ) {
      darn
      georoles {
        roleName
        structures {
          type
          code
          name
        }
      }
    }
  }
`;

export function useAddGeorole(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, MutationParams>(
    addMutation
  );

  if (error != null) throw error;

  const action = useCallback(
    async (
      idnumber: string,
      roleName: string,
      structures: StructParams[]
    ): Promise<void> => {
      // remove superfluous fields which break GraphQL input
      const cleanStructures = structures.map(({ type, code }) => ({
        type,
        code,
      }));
      await mutate({
        variables: { idnumber, roleName, structures: cleanStructures },
      });
    },
    [mutate]
  );

  return [action, { loading }];
}

const removeMutation = gql`
  mutation removeGeorole(
    $idnumber: String!
    $roleName: String!
    $structures: [StructureInput]!
  ) {
    revokeGeorole(
      idnumber: $idnumber
      roleName: $roleName
      structures: $structures
    ) {
      darn
      georoles {
        roleName
        structures {
          type
          code
          name
        }
      }
    }
  }
`;

export function useRemoveGeorole(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, MutationParams>(
    removeMutation
  );

  if (error != null) throw error;

  const action = useCallback(
    async (
      idnumber: string,
      roleName: string,
      structures: StructParams[]
    ): Promise<void> => {
      // remove superfluous fields which break GraphQL input
      const cleanStructures = structures.map(({ type, code }) => ({
        type,
        code,
      }));
      await mutate({
        variables: { idnumber, roleName, structures: cleanStructures },
      });
    },
    [mutate]
  );

  return [action, { loading }];
}
